import { AppShell, Container } from "@mantine/core";
import { type PropsWithChildren } from "react";

import { useAuth } from "@/api/resources/auth/hooks";
import LayoutFooter from "@/components/Layout/LayoutFooter";

export const LayoutHeaderless = ({ children }: PropsWithChildren) => {
  const { isAuthenticated } = useAuth();
  return (
    <AppShell
      withBorder={false}
      footer={{
        height: "auto",
        offset: false,
      }}
      padding={{
        base: "xs",
        sm: "lg",
      }}
    >
      <AppShell.Main>
        <Container size="lg">{children}</Container>
      </AppShell.Main>

      {!isAuthenticated && (
        <AppShell.Footer>
          <LayoutFooter />
        </AppShell.Footer>
      )}
    </AppShell>
  );
};

export default LayoutHeaderless;
